import { useAppMode } from '../../context/AppModeContext';

export function AiUsageMeter() {
  const { aiTier, aiUsage } = useAppMode();

  if (!aiUsage) return null;

  const { count, limit } = aiUsage;
  const pct = Math.min((count / limit) * 100, 100);
  const remaining = limit - count;

  let barColor = 'var(--success, #22c55e)';

  if (pct >= 95) {
    barColor = 'var(--error, #ef4444)';
  } else if (pct >= 80) {
    barColor = 'var(--warning, #eab308)';
  }

  const label = aiTier === 'free'
    ? (remaining <= 0
        ? 'Free scans used — add your own API key or upgrade to Pro'
        : `${count} / ${limit} free scans used · ${remaining} remaining`)
    : (remaining <= 0
        ? 'Monthly limit reached — resets on your next billing cycle'
        : `${count} / ${limit} used · ${remaining} remaining`);

  return (
    <div className="mt-2 w-full">
      <div className="text-xs text-center" style={{ color: 'var(--text-muted)' }}>
        {label}
      </div>
      <div
        className="mt-1 h-1.5 w-full overflow-hidden rounded-full"
        style={{ background: 'var(--bg-tertiary)' }}
      >
        <div
          className="h-full rounded-full transition-all duration-300"
          style={{ width: `${pct}%`, background: barColor }}
        />
      </div>
    </div>
  );
}
